import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-close",
  "use": "menu-close-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"menu-close\"><path fill-rule=\"evenodd\" d=\"M36.456 11l1.414 1.414-12.02 12.021 12.021 12.02-1.414 1.415-12.022-12.02-12.02 12.02L11 36.456l12.02-12.021L11 12.415 12.414 11l12.021 12.02L36.455 11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol